const getters = {
  getBreadcrumbs: (state) => {
    return state.breadcrumbs;
  },
};

export { getters };
